@if (displayNotif) {
  <div [class]="className">
    <span [innerHTML]="message"></span>
    <ng-content></ng-content>
  </div>
}
